@use "@fukuri-admins/ui/layout" as *;

.cell {
  border-bottom: 1px solid border('Tertiary');
  @include typography('Jp/14_W3');
  color: text('High');
  vertical-align: middle;
}

.sizeDefault {
  padding: spacing('8') spacing('12');
}

.sizeMd {
  padding: spacing('12') spacing('12');
}

.sizeLg {
  padding: spacing('16') spacing('12');
}

.alignLeft {
  text-align: left;
}

.alignCenter {
  text-align: center;
}

.alignRight {
  text-align: right;
}
